import {rqCreateRequest} from '@app/reactQuery/apis/rqHttpsUtils';
import {RQ_CREATE_LEAVE_API} from '@app/reactQuery/apis/constants';

export const RQPutCreateLeavesApply = ({leave, certificate, signal}) => {
  return rqCreateRequest(
    RQ_CREATE_LEAVE_API,
    JSON.stringify({...leave}),
    certificate,
    null,
    signal,
  );
};
